import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { ApiClientService } from '../../../../services/api-client.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { UrlService } from '../../../../services/url.service';
import { NgForm } from '@angular/forms';
import { ConstantsService } from '../../../../services/constants.service';
import {ManagementCompanyService} from '../services/management-company.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'company-invitation-email-modal',
    templateUrl: './company-invitation-email-modal.component.html',
    styleUrls: ['./company-invitation-email-modal.component.scss']
})
export class CompanyInvitationEmailModalComponent implements OnInit {
    @Input('type') type: 'invitation'|'reset_password';
    @Input('company-id') companyId: number;
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    showSpinner = false;
    originalSubject = '';
    originalMessage = '';
    emailMessage = '';
    emailSubject = '';
    placeholders = [
        '[[FULL_NAME]]',
        '[[INVITATION_LINK]]',
        '[[PROPERTY_MANAGEMENT_COMPANY]]',
    ];

    constructor(
        public api: ApiClientService,
        public managementCompany: ManagementCompanyService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        this.showSpinner = true;
        this.managementCompany.view(this.companyId).subscribe(res => {
            this.showSpinner = false;
            switch(this.type) {
                case 'invitation':
                    this.emailMessage = res.inviteTemplate;
                    this.emailSubject = res.inviteSubject;
                    this.originalSubject = res.inviteSubject;
                    this.originalMessage = res.inviteTemplate;
                    break;
                case 'reset_password':
                    this.emailMessage = res.resetPasswordTemplate;
                    this.emailSubject = res.resetPasswordSubject;
                    this.originalSubject = res.resetPasswordSubject;
                    this.originalMessage = res.resetPasswordTemplate;
                    break;
            }
        })
    }

    hideModal() {
        if (this.showEditPanel) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.managementCompany.invitationEmailModal = null
            );
        } else
            this.managementCompany.invitationEmailModal = null;
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    onSubmit(form: NgForm) {
        if (this.emailMessage == '' || (this.emailMessage.replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
            toastr.warning('Email Message should not be blank.');
            return;
        }


        if (this.emailSubject == '') {
            toastr.warning('Email Subject should not be blank.');
            return;
        }

        this.disabledSubmit = true;
        this.showSpinner = true;

        let data = {};
        switch(this.type) {
            case 'invitation':
                data = {
                    inviteTemplate: this.emailMessage,
                    inviteSubject: this.emailSubject,
                }
                break;
            case 'reset_password':
                data = {
                    resetPasswordTemplate: this.emailMessage,
                    resetPasswordSubject: this.emailSubject,
                }
                break;
        }

        this.managementCompany.update(this.companyId, data).subscribe(
            () => {
                this.showSpinner = false;
                toastr.success('Template has been modified successfully.');
                this.managementCompany.invitationEmailModal = null;
            },
            error => {
                this.showSpinner = false;
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed update company');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.hideModal();
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.emailMessage = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.emailMessage).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.emailMessage).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeEditPanel() {
        this.showEditPanel = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-invitation-email-modal/company-invitation-email-modal.component.ts